import { getWorkkeysReplaceTerm } from "../../helpers/workkeysReplaceTerms"
import {
  getCertainOrgFiltersMap,
  getOrgFiltersMap
} from "../../helpers/filters"
import {
  isBooleanLikeTrue,
  rawScoreColumnFormatter,
  scoresColumnFormatter
} from "../../helpers/scores"
import {
  formatCorrectAnswers,
  formatStudentAnswer,
  isStudentAnswerCorrect
} from "../../helpers/tables"
import { reportingCategoriesAndStandardsFormatter } from "../../helpers/tables/content"
// import { getScoresContentLink } from "../../helpers/tables/insights"
import { questionsSkillsFormatter } from "../../helpers/tables/performance"
import { TableData } from "./types"

export const QUESTIONS: TableData = {
  columns: [
    {
      label: "Content",
      name: "questions_view.displayName",
      sortable: true
    },
    {
      label: "Content Level",
      name: "questions_view.testLevel",
      sortable: false
    },
    {
      label: "Number",
      name: "questions_view.number",
      sortableName: "questions_view.seq",
      sortable: true,
      align: "right"
    },
    {
      label: "Correct Answer",
      name: "questions_view.answers",
      sortable: false,
      type: "correctAnswers",
      formatter: formatCorrectAnswers
    },
    // {
    //   label: "Viewed",
    //   name: "questions_view.viewedCount",
    //   sortable: true,
    //   type: "number",
    //   align: "right"
    // },
    {
      label: "Answered",
      name: "questions_view.answersCount",
      sortable: true,
      type: "number",
      align: "right"
    },
    {
      label: "% Correct",
      name: "questions_view.correctPercent",
      sortable: true,
      type: "correctPercent",
      align: "right",
      formatter: (record, prop) => {
        return Number(record[prop] || 0) / 100
      }
    },
    // {
    //   label: "Standard",
    //   name: "questions_view.standards",
    //   sortable: true,
    //   formatter: reportingCategoriesAndStandardsFormatter
    // },
    {
      label: "Skills",
      name: "questions_view.reportingCategories",
      sortable: true,
      formatter: questionsSkillsFormatter
    }
  ],
  displayedProperties: [
    // "questions_view.id",
    "questions_view.displayName",
    "questions_view.testLevel",
    "questions_view.number",
    "questions_view.seq",
    "questions_view.answers",
    "questions_view.standards",
    "questions_view.reportingCategories",
    "questions_view.viewedCount",
    "questions_view.answersCount",
    "questions_view.correctPercent",
    "questions_view.program",
    "questions_view.subject",
    "questions_view.questionRefId",
    "questions_view.testType"
  ],
  requestParams: {
    dimensions: [
      "questions_view.id",
      "questions_view.testId",
      "questions_view.subtestId",
      "questions_view.contentId",
      "questions_view.displayName",
      "questions_view.testLevel",
      "questions_view.number",
      "questions_view.seq",
      "questions_view.answers",
      "questions_view.standards",
      "questions_view.reportingCategories",
      "questions_view.program",
      "questions_view.subject",
      "questions_view.questionRefId",
      "questions_view.testType"
    ],
    measures: [
      "questions_view.viewedCount",
      "questions_view.answersCount",
      "questions_view.correctPercent"
    ]
  },
  requestFilterMap: {
    ...getOrgFiltersMap("questions_view"),
    "content_view_subtests.id": "questions_view.subtestId",
    "tests.program": "questions_view.program",
    "tests.subject": "questions_view.subject",
    level: "questions_view.testLevel",
    "content.skill": "questions_view.skillsTreeIds"
  },
  tableOptions: {
    searchPlaceholder: "Questions",
    pageName: "Questions",
    selectable: false,
    caption: "List of questions"
  },
  searchRequestParams: ["questions_view.displayName"],
  alertPageTitle: "Questions"
}

export const STUDENT_QUESTIONS: TableData = {
  columns: [
    {
      label: "Content",
      name: "questions_view.displayName",
      sortable: true
    },
    {
      label: "Number",
      name: "questions_view.number",
      sortableName: "questions_view.seq",
      sortable: true,
      align: "right"
    },
    {
      label: "Correct Answer",
      name: "questions_view.answers",
      sortable: false,
      type: "correctAnswers",
      formatter: formatCorrectAnswers
    },
    {
      label: "Submitted Answer",
      name: "questions_view.response",
      type: "correct",
      typeProp: isStudentAnswerCorrect,
      formatter: formatStudentAnswer,
      sortable: false
    },
    {
      label: "Attempts",
      name: "questions_view.attempt",
      sortable: true,
      align: "right"
    },
    {
      label: "Standard",
      name: "questions_view.standards",
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Skills",
      name: "questions_view.reportingCategories",
      sortable: true,
      formatter: questionsSkillsFormatter
    }
  ],
  displayedProperties: [
    // "questions_view.id",
    "questions_view.displayName",
    "questions_view.number",
    "questions_view.seq",
    "questions_view.answers",
    "questions_view.response",
    "questions_view.responseKey",
    "questions_view.testType",
    "questions_view.attempt",
    "questions_view.standards",
    "questions_view.reportingCategories",
    "questions_view.program",
    "questions_view.subject",
    "questions_view.questionRefId",
    "questions_view.testType"
  ],
  requestParams: {
    dimensions: [
      "questions_view.id",
      "questions_view.testId",
      "questions_view.subtestId",
      "questions_view.contentId",
      "questions_view.displayName",
      "questions_view.number",
      "questions_view.seq",
      "questions_view.answers",
      "questions_view.response",
      "questions_view.responseKey",
      "questions_view.testType",
      "questions_view.attempt",
      "questions_view.standards",
      "questions_view.reportingCategories",
      "questions_view.program",
      "questions_view.subject",
      "questions_view.questionRefId",
      "questions_view.testType"
    ]
  },
  requestFilterMap: {
    ...getOrgFiltersMap("questions_view"),
    "content_view_subtests.id": "questions_view.subtestId",
    "tests.program": "questions_view.program",
    "tests.subject": "questions_view.subject",
    level: "questions_view.testLevel",
    "content.skill": "questions_view.skillsTreeIds"
  },
  tableOptions: {
    searchPlaceholder: "Questions",
    selectable: false,
    caption: `List of ${getWorkkeysReplaceTerm("student")} questions`
  },
  searchRequestParams: ["questions_view.displayName"],
  alertPageTitle: "Questions"
}

export const ANSWERS: TableData = {
  columns: [],
  displayedProperties: [],
  requestParams: {
    dimensions: [],
    measures: []
  },
  requestFilterMap: {
    ...getOrgFiltersMap("questions_view"),
    "content_view_subtests.id": "questions_view.subtestId"
  },
  searchRequestParams: [],
  tableOptions: {
    pageName: "Answers",
    selectable: false,
    caption: "List of answers"
  }
}

export const SCORES: TableData = {
  columns: [
    {
      label: "Name",
      name: "scores_view.studentName",
      sortable: true,
      mask: true,
      type: "link",
      typeProp: "scores_view.studentId",
      linkUrl: "/reporting/organization/learners",
      linkTooltip: record =>
        `View ${record["scores_view.studentName"]} ${getWorkkeysReplaceTerm(
          "student",
          true
        )}`,
      size: 250
    },
    {
      label: "Learner ID",
      name: "scores_view.externalStudentId",
      sortable: true,
      mask: true,
      size: 150
    },
    { label: "Grade", name: "scores_view.grade", sortable: false, size: 100 },
    {
      label: "Content",
      name: "scores_view.testDisplayName",
      sortable: true,
      type: "link",
      typeProp: "scores_view.testId",
      // ! Commented out per Ready#5764
      // linkUrl: () => getScoresContentLink("practice-test"),
      // linkTooltip: record =>
      //   `View ${record["scores_view.testDisplayName"]} Test`,
      size: 250
    },
    {
      label: "Attempt",
      name: "scores_view.attempt",
      sortable: true,
      type: "number",
      align: "right",
      size: 80
    },
    {
      label: "Completed",
      name: "scores_view.completedAt",
      sortable: true,
      type: "dateTime",
      size: 200
    },
    {
      label: "Score",
      name: "scores_view.scale",
      sortable: false,
      type: "link",
      linkUrl: "",
      linkTooltip: () => "View Performance",
      formatter: (record, prop) =>
        scoresColumnFormatter(
          record["scores_view.program"],
          isBooleanLikeTrue(record["scores_view.isDiagnosticForACT"]),
          record[prop]
        ),
      size: 70
    },
    {
      label: "Raw Score",
      name: "scores_view.raw",
      sortable: true,
      type: "link",
      linkUrl: "",
      linkTooltip: () => "View Answers",
      align: "right",
      size: 90
    }
  ],
  displayedProperties: [
    // "scores_view.id",
    "scores_view.studentName",
    "scores_view.testDisplayName",
    "scores_view.completedAt",
    "scores_view.scale",
    "scores_view.raw",
    "scores_view.attempt",
    "scores_view.program",
    "scores_view.subtestIds",
    "scores_view.subtestScores",
    "scores_view.isDiagnosticForACT",
    "scores_view.content",
    "scores_view.practiceTestType"
  ],
  requestParams: {
    dimensions: [
      "scores_view.id",
      "scores_view.studentName",
      "scores_view.testDisplayName",
      "scores_view.program",
      "scores_view.testId",
      "scores_view.attempt",
      "scores_view.isCompleted",
      "scores_view.completedAt",
      "scores_view.isDiagnosticForACT",
      "scores_view.raw",
      "scores_view.scale",
      "scores_view.state",
      "scores_view.districtId",
      "scores_view.schoolId",
      "scores_view.studentId",
      "scores_view.userAssessmentId",
      "scores_view.subtestIds",
      "scores_view.subtestScores",
      "scores_view.externalStudentId",
      "scores_view.content",
      "scores_view.practiceTestType",
      "scores_view.grade"
    ],
    filters: [
      {
        member: "scores_view.isCompleted",
        operator: "equals",
        values: ["true"]
      }
    ]
  },
  requestFilterMap: {
    ...getOrgFiltersMap("scores_view"),
    "content_view_subtests.id": "scores_view.subtestIds",
    "content_view_list.id": "scores_view.testId",
    "tests.program": "scores_view.program"
    // "content_view_list.id": "scores_view.testId"
  },
  alertPageTitle: "Scores",
  tableOptions: {
    searchPlaceholder: "Scores",
    pageName: "Scores",
    selectable: false,
    caption: `List of ${getWorkkeysReplaceTerm("student", true)} scores`
  },
  searchRequestParams: [
    "scores_view.studentName",
    "scores_view.externalStudentId"
  ]
}

export const SCORES_SUBTEST: TableData = {
  columns: [
    {
      label: "Name",
      name: "scores_subtests_view.studentName",
      sortable: true,
      mask: true,
      type: "link",
      typeProp: "scores_subtests_view.studentId",
      linkUrl: "/reporting/organization/learners",
      linkTooltip: record =>
        `View ${
          record["scores_subtests_view.studentName"]
        } ${getWorkkeysReplaceTerm("student", true)}`,
      size: 250
    },
    {
      label: "Learner ID",
      name: "scores_subtests_view.externalStudentId",
      sortable: true,
      mask: true,
      size: 150
    },
    {
      label: "Grade",
      name: "scores_subtests_view.grade",
      sortable: false,
      size: 100
    },
    {
      label: "Content",
      name: "scores_subtests_view.subtestName",
      sortable: true,
      type: "link",
      // ! Commented out per Ready#5764
      // linkUrl: record => getScoresContentLink("practice-test"),
      // linkTooltip: record =>
      //   `View ${record["scores_subtests_view.subtestName"]} Test`,
      size: 250
    },
    {
      label: "Content Level",
      name: "scores_subtests_view.testLevel",
      sortable: false,
      size: 120
    },
    {
      label: "Attempt",
      name: "scores_subtests_view.attempt",
      sortable: true,
      type: "number",
      align: "right",
      size: 80
    },
    {
      label: "Completed",
      name: "scores_subtests_view.completedAt",
      sortable: true,
      type: "dateTime",
      size: 200
    },
    {
      label: "Score",
      name: "scores_subtests_view.scale",
      sortable: false,
      type: "link",
      linkUrl: "",
      linkTooltip: () => "View Performance",
      formatter: (record, prop, context) => {
        const gradeLevel = (() => {
          if( record.gradeLevel ) {
            return record.gradeLevel
          }
          if( (record?.gradeLevels || record?.gradeLevelNames) ) {
            return {
              "subtests_grade_levels.gradeLevels": record.gradeLevels,
              "subtests_grade_levels.gradeLevelNames": record.gradeLevelNames,
            }
          }
          return undefined
        })()
        // Cube did this in the backend
        const isFinalQuiz = !!record.content?.match(/end of level/i) || !!record.content?.match(/final quiz/i) || !!record.content?.match(/PRUEBA DEL NIVEL/i)
        return scoresColumnFormatter(
          record["scores_subtests_view.program"],
          isBooleanLikeTrue(record["scores_subtests_view.isDiagnosticForACT"]),
          record[prop],
          record["scores_subtests_view.subtestId"],
          gradeLevel,
          context,
          {
            isDiagnostic: isBooleanLikeTrue(record["scores_subtests_view.isDiagnostic"]),
            answeredCount: Number(record["scores_subtests_view.raw"]),
            questionCount: Number(
              record["scores_subtests_view.totalQuestionsCount"]
            )
          },
          record["scores_subtests_view.isFinalQuiz"] || isFinalQuiz
        )
      },
      size: 70
    },
    {
      label: "Raw Score",
      name: "scores_subtests_view.raw",
      sortable: true,
      type: "link",
      linkUrl: "",
      linkTooltip: () => "View Answers",
      formatter: (record, prop) =>
        rawScoreColumnFormatter({
          rawScore: record[prop],
          totalQuestions: record["scores_subtests_view.totalQuestionsCount"]
        }),
      align: "right",
      size: 90
    }
  ],
  displayedProperties: [
    // "scores_subtests_view.id",
    "scores_subtests_view.studentName",
    "scores_subtests_view.subtestName",
    "scores_subtests_view.attempt",
    "scores_subtests_view.completedAt",
    "scores_subtests_view.scale",
    "scores_subtests_view.raw",
    "scores_subtests_view.isDiagnosticForACT",
    "scores_subtests_view.isDiagnostic",
    "scores_subtests_view.program",
    "scores_subtests_view.subject",
    "scores_subtests_view.testId",
    "scores_subtests_view.testLevel",
    "scores_subtests_view.subtestId",
    "scores_subtests_view.content",
    "scores_subtests_view.practiceTestType",
    "scores_subtests_view.totalQuestionsCount",
    "scores_subtests_view.isFinalQuiz"
  ],
  requestParams: {
    dimensions: [
      "scores_subtests_view.studentName",
      "scores_subtests_view.studentId",
      "scores_subtests_view.content",
      "scores_subtests_view.testLevel",
      "scores_subtests_view.program",
      "scores_subtests_view.subject",
      "scores_subtests_view.subtestName",
      "scores_subtests_view.completedAt",
      "scores_subtests_view.attempt",
      "scores_subtests_view.scale",
      "scores_subtests_view.raw",
      "scores_subtests_view.testId",
      "scores_subtests_view.isCompleted",
      "scores_subtests_view.subtestId",
      "scores_subtests_view.isDiagnosticForACT",
      "scores_subtests_view.isDiagnostic",
      "scores_subtests_view.state",
      "scores_subtests_view.districtId",
      "scores_subtests_view.schoolId",
      "scores_subtests_view.studentId",
      "scores_subtests_view.userAssessmentId",
      "scores_subtests_view.externalStudentId",
      "scores_subtests_view.practiceTestType",
      "scores_subtests_view.totalQuestionsCount",
      "scores_subtests_view.isFinalQuiz",
      "scores_subtests_view.grade"
    ],
    filters: [
      {
        member: "scores_subtests_view.isCompleted",
        operator: "equals",
        values: ["true"]
      }
    ]
  },
  requestFilterMap: {
    ...getOrgFiltersMap("scores_subtests_view"),
    "content_view_list.id": "scores_subtests_view.testId",
    "content_view_subtests.id": "scores_subtests_view.subtestId",
    "tests.program": "scores_subtests_view.program",
    "tests.subject": "scores_subtests_view.subject",
    level: "scores_subtests_view.testLevel"
    // "content_view_list.id": "scores_subtests_view.testId"
  },
  tableOptions: {
    searchPlaceholder: "Scores",
    pageName: "Scores",
    selectable: false,
    caption: "List of subtest scores"
  },
  alertPageTitle: "Scores",
  searchRequestParams: [
    "scores_subtests_view.studentName",
    "scores_subtests_view.externalStudentId"
  ]
}

export const GOALS: TableData = {
  columns: [],
  displayedProperties: [],
  requestParams: {
    dimensions: [],
    measures: [],
    filters: [],
    timeDimensions: [],
    order: undefined
  },
  requestFilterMap: undefined,
  searchRequestParams: [],
  tableOptions: {
    pageName: "Goals",
    caption: "List of goals"
  },
  alertPageTitle: "Goals Summary"
}

export const GOALS_SUMMARY_BY_PROGRAM_SUBPAGE =
  "goals-summary-by-program-subpage"
export const GOALS_SUMMARY_BY_PROGRAM: TableData = {
  columns: [],
  displayedProperties: [],
  requestParams: {},
  requestFilterMap: {
    ...getCertainOrgFiltersMap("goals_summary_by_program", [
      "state",
      "district",
      "school",
      "teacher",
      "class",
      "student",
      "grade"
    ]),
    "tests.program": "goals_summary_by_program.program"
  },
  searchRequestParams: [],
  tableOptions: {
    pageName: "Goals",
    caption: "List of goals by program and subject"
  },
  alertPageTitle: "Goals Summary"
}

export const GOALS_SUMMARY_BY_SUBJECT_SUBPAGE =
  "goals-summary-by-subject-subpage"
export const GOALS_SUMMARY_BY_SUBJECT: TableData = {
  columns: [],
  displayedProperties: [],
  requestParams: {},
  requestFilterMap: {
    ...getCertainOrgFiltersMap("goals_summary_by_subject", [
      "state",
      "district",
      "school",
      "teacher",
      "class",
      "student",
      "grade"
    ]),
    "tests.program": "goals_summary_by_subject.program",
    "tests.subject": "goals_summary_by_subject.subject"
  },
  searchRequestParams: []
}

export const SCORE_GOALS_BY_PROGRAM_VIEW_SUBPAGE =
  "score-goals-by-program-view-subpage"
export const SCORE_GOALS_BY_PROGRAM_VIEW: TableData = {
  columns: [],
  displayedProperties: [],
  requestParams: {},
  requestFilterMap: {
    ...getCertainOrgFiltersMap("score_goals_by_program_view", [
      "state",
      "district",
      "school",
      "teacher",
      "class",
      "student",
      "grade"
    ]),
    "tests.program": "score_goals_by_program_view.program"
  },
  searchRequestParams: []
}

export const SCORE_GOALS_BY_SUBJECT_VIEW_SUBPAGE =
  "score-goals-by-subject-view-subpage"
export const SCORE_GOALS_BY_SUBJECT_VIEW: TableData = {
  columns: [],
  displayedProperties: [],
  requestParams: {},
  requestFilterMap: {
    ...getCertainOrgFiltersMap("score_goals_by_subject_view", [
      "state",
      "district",
      "school",
      "teacher",
      "class",
      "student",
      "grade"
    ]),
    "tests.program": "score_goals_by_subject_view.program",
    "tests.subject": "score_goals_by_subject_view.subject"
  },
  searchRequestParams: []
}

export const GOALS_SCORE_RANGE_BY_TEST_SUBPAGE = "goals-score-range-by-test"
export const GOALS_SCORE_RANGE_BY_TEST: TableData = {
  columns: [
    {
      label: "Name",
      name: "test_view_students_by_test.studentName",
      type: "link",
      mask: true,
      typeProp: "test_view_students_by_test.studentId",
      linkUrl: "/reporting/organization/learners",
      linkTooltip: record =>
        `View ${record["test_view_students_by_test.studentName"]}`,
      sortable: true,
      size: 800
    },
    {
      label: "Most Recent Score",
      name: "test_view_students_by_test.latestScore",
      sortable: true,
      size: 135
    },
    {
      label: "Raw Score",
      name: "test_view_students_by_test.latestRaw",
      sortable: true,
      align: "right",
      type: "link",
      size: 90
    }
  ],
  displayedProperties: [
    "test_view_students_by_test.studentName",
    "test_view_students_by_test.latestScore",
    "test_view_students_by_test.latestRaw"
  ],
  requestParams: {
    dimensions: [
      "test_view_students_by_test.studentId",
      "test_view_students_by_test.studentName",
      "test_view_students_by_test.latestRaw",
      "test_view_students_by_test.latestScore"
    ]
  },
  requestFilterMap: {
    ...getOrgFiltersMap("test_view_students_by_test"),
    "tests.program": "test_view_students_by_test.program",
    score: "test_view_students_by_test.latestScore"
  },
  searchRequestParams: ["test_view_students_by_test.studentName"],
  tableOptions: {
    searchPlaceholder: "Students",
    pageName: "Goals",
    selectable: false,
    caption: "List of goals by test"
  },
  alertPageTitle: "Goals Summary"
}

export const GOALS_SCORE_RANGE_BY_SUBJECT_SUBPAGE =
  "goals-score-range-by-subject"
export const GOALS_SCORE_RANGE_BY_SUBJECT: TableData = {
  columns: [
    {
      label: "Name",
      name: "test_view_students_by_subject.studentName",
      type: "link",
      mask: true,
      typeProp: "test_view_students_by_subject.studentId",
      linkUrl: "/reporting/organization/learners",
      linkTooltip: record =>
        `View ${record["test_view_students_by_subject.studentName"]}`,
      sortable: true,
      size: 800
    },
    {
      label: "Most Recent Score",
      name: "test_view_students_by_subject.latestScore",
      sortable: true,
      size: 135
    },
    {
      label: "Raw Score",
      name: "test_view_students_by_subject.latestRaw",
      sortable: true,
      align: "right",
      type: "link",
      size: 90
    }
  ],
  displayedProperties: [
    "test_view_students_by_subject.studentName",
    "test_view_students_by_subject.latestScore",
    "test_view_students_by_subject.latestRaw"
  ],
  requestParams: {
    dimensions: [
      "test_view_students_by_subject.studentId",
      "test_view_students_by_subject.studentName",
      "test_view_students_by_subject.latestRaw",
      "test_view_students_by_subject.latestScore"
    ]
  },
  requestFilterMap: {
    ...getOrgFiltersMap("test_view_students_by_subject"),
    "tests.program": "test_view_students_by_subject.program",
    "tests.subject": "test_view_students_by_subject.subject",
    score: "test_view_students_by_subject.latestScore"
  },
  searchRequestParams: ["test_view_students_by_subject.studentName"],
  tableOptions: {
    searchPlaceholder: "Students",
    pageName: "Goals",
    selectable: false,
    caption: "List of goals by subject"
  },
  alertPageTitle: "Goals Summary"
}
